import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
  Typography,
  Checkbox,
  Link,
  IconButton,
  TableHead,
  TableContainer,
  Paper,
} from '@material-ui/core';
import HTMLtoDOCX from 'html-to-docx';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import EditIcon from '@material-ui/icons/EditOutlined';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import { ArrowBack, ArrowForward } from '@material-ui/icons';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import { AiOutlineLine } from 'react-icons/ai';
import KenGridEditable from '../../../global_components/kenEditDataGrid/kenGridEditable';
import { RiCheckFill } from 'react-icons/ri';
import { RiFilterLine } from 'react-icons/ri';
import { HiOutlinePencilAlt, HiOutlineTrash } from 'react-icons/hi';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../Components/BreadCrumb';
import { useHistory, useLocation } from 'react-router-dom';
import routes from '../../../Utils/routes.json';
import KenSelect from '../../../global_components/KenSelect';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import KenCard from '../../../global_components/KenCard';
import KenGrid from '../../../global_components/KenGrid';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenPopover from '../../../Components/KenPopOver';
import {
  selectOptions,
  todayDropDown,
  intakeOptions,
  selectOptionsSection,
  courses,
  yearOptions,
  modeDropdown,
} from './data/data';
import KenInputField from '../../../global_components/KenInputField';
import { AiOutlineMinusSquare } from 'react-icons/ai';
import { AiOutlinePlusSquare } from 'react-icons/ai';
import ProgramFilter from './ProgramFilter';
import KenDialog from '../../../global_components/KenDialogBox';
import KenLoader from '../../../Components/KenLoader/index';
import FormControl from '@material-ui/core/FormControl';
import KenSnackBar from '../../../Components/KenSnackbar';
import RadioGroup from '@material-ui/core/RadioGroup';
import './addActivity.css';
import {
  getAcademicFilter,
  getAcademicPlannerData,
  postAcademicPlanner,
  getMasterActivityWithTermData,
  getImportTermActivity,
  getFacultyAndFacilty,
  getCourseVersion,
  getTermData,
  getAcademicCalendar,
  getAcademicCalendarNew,
  getDataForCourseEnrolment,
  postAcademicCalendar,
  postTermDatesUpdate,
} from '../../../Utils/apiServices';
import Reference from './Reference';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import KenAutoComplete from '../../../global_components/KenAutoComplete';
import KenCheckbox from '../../../global_components/KenCheckbox';
import { asBlob } from 'html-docx-js-typescript';
import { saveAs } from 'file-saver';
const arrayBreadCrumb = [
  { head: 'HOME', url: routes.home },
  {
    head: 'ADD TERM ACADEMIC PLANNER',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  dateLabels: {
    lineHeight: '42px',
    marginRight: '10px',
    fontSize: '12px',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },

  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  holidayButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    marginRight: '5px',
  },
  fitlerButton: {
    textTransform: 'none',
    fontWeight: 'bold',
  },
  sortingSection: {
    display: 'grid',
    gap: '10px',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
  mainActions: {
    textAlign: 'right',
  },
  popOverHeading: {
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    color: '#02195E',
  },
  tableBodyStyle: {
    fontSize: '12px',
    color: '#7A869A',
  },
  tableBodyStyleIgnoreHoliday: {
    fontSize: '12px',
    color: '#7A869A',
    padding: '0px',
  },
  textInputFieldDropDown: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  textInputField: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  kenDateTimePickerColor: {
    backgroundColor: '#fff',
  },
  noDataFound: {
    fontWeight: '600',
    fontSize: '14px',
  },
  filterButton: {
    marginRight: '10px',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    height: '28px',
    width: '78px',
    marginTop: '18px',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  goBack: {
    margin: '0px',
    textAlign: 'right',
  },
}));

const ActionCell = (row) => {
  return (
    <Box>
      <Button
        size="small"
        variant="contained"
        color="primary"
        className="add-program-button"
        style={{ borderRadius: 15 }}
        startIcon={<HiOutlinePencilAlt className="m-0" />}
      >
        Edit
      </Button>{' '}
      <Button
        size="small"
        variant="contained"
        color="primary"
        className="add-program-button"
        style={{ borderRadius: 15 }}
        startIcon={<HiOutlineTrash className="m-0" />}
      >
        Delete
      </Button>
    </Box>
  );
};

const columns = [
  {
    Header: 'ID',
    accessor: 'id',
    disableGlobalFilter: true,
  },
  {
    Header: 'activity',
    accessor: 'activity',
    disableGlobalFilter: true,
  },
  {
    Header: 'Subject',
    accessor: 'subject',
    disableGlobalFilter: true,
  },
  {
    Header: 'Faculty',
    accessor: 'faculty',
    disableGlobalFilter: true,
  },
  {
    Header: 'Start Date',
    accessor: 'start_date',
    disableGlobalFilter: true,
  },
  {
    Header: 'End Date',
    accessor: 'end_date',
    disableGlobalFilter: true,
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    Cell: ActionCell,
  },
];

const masterHead = [
  {
    Header: 'Week No.',
    accessor: 'durationInWeeks',
    disableGlobalFilter: false,
  },
  {
    Header: 'Activity',
    accessor: 'activity',
    disableGlobalFilter: false,
  },
  {
    Header: 'Subject',
    accessor: 'subject',
    disableGlobalFilter: false,
  },
  {
    Header: 'Faculty',
    accessor: 'faculty',
    disableGlobalFilter: false,
  },
  {
    Header: 'Start Date',
    accessor: 'startDate',
    disableGlobalFilter: false,
  },
  {
    Header: 'End Date',
    accessor: 'endDate',
    disableGlobalFilter: false,
  },
];
const createData = (
  id,
  weekNo,
  activity,
  subject,
  faculty,
  startDate,
  endDate,
  saved
) => ({
  id,
  weekNo,
  activity,
  subject,
  faculty,
  startDate,
  endDate,
  saved,
});
const selectOptionsSubject = [
  { label: 'Lecture', value: 'Lecture' },
  { label: 'Exam', value: 'Exam' },
  { label: 'Lab', value: 'Lab' },
  { label: 'Tutorial', value: 'Tutorial' },
  { label: 'Practical', value: 'Term Break' },
  { label: 'Workshop', value: 'Workshop' },
  { label: 'Travel', value: 'Travel' },
  { label: 'Term Break', value: 'Term Break' },
  { label: 'Holiday', value: 'Holiday' },
  { label: 'Other', value: 'Other' },
];

const defaultValues = {
  programFrom: '',
  intakeFrom: '',
  courseFrom: '',
  startDateFrom: '',
  endDateFrom: '',
  programTO: '',
  intakeTO: '',
  courseTO: '',
  startDateTO: '',
  endDateTO: '',
};

const AddActivity = (props) => {
  const history = useHistory();
  const userDetails = localStorage.getItem('userDetails');
  const classes = useStyles();
  const location = useLocation();
  const [value, setValue] = React.useState('Online');
  const [startDay, setStartDay] = useState(todayDropDown[0].value);
  const [endDay, setEndDay] = useState(todayDropDown[0].value);
  const [term, setTerm] = useState(
    sessionStorage.getItem('term') || location?.state?.term
  );
  const [termDropdown, setTermDropdown] = useState([]);
  const [termOptions, setTermOptions] = useState([]);
  const [startDate, setStartDate] = useState('25-02-2022');
  const [endDate, setEndDate] = useState('25-02-2022');
  const [termStart, setTermStart] = useState('');
  const [termEnd, setTermEnd] = useState('');
  const [totalDay, setTotalDay] = useState('');
  const [totalHrWeek, setTotalHrWeek] = useState('');
  const [selectValue, setSelectValue] = useState(selectOptions[0].value);
  const [accordienCheck, setAccordienCheck] = useState(true);
  const [masterAccordian, setMasterAccordian] = useState(true);
  const [selectSectionValue, setSelectSectionValue] = useState(
    selectOptionsSection[0].value
  );
  const [selectValueSubject, setSelectValueSubject] = useState(
    selectOptionsSubject[0].value
  );
  const [formValues, setFormValues] = useState(defaultValues);
  const [loading, setLoading] = React.useState(false);
  const [cloneDialog, setCloneDialog] = useState(false);
  const [masterData, setMasterData] = useState([]);
  const [masterDialog, setMasterDialog] = useState(false);
  const [masterImportSuccess, setMasterImportSuccess] = useState(false);
  const [disableMaster, setDisableMaster] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEls, setAnchorEls] = useState(null);
  const [anchorElIgnore, setAnchorElIgnore] = useState(null);
  const [isFiltered, setIsFiltered] = useState(false);
  const [filters, setFilters] = useState({});
  const [programName, setProgramName] = useState(
    location?.state?.programName || ''
  );
  const [programName2, setProgramName2] = useState([]);
  const [intake, setIntake] = useState(
    location?.state?.intake || sessionStorage.getItem('intake')
  );
  const [year, setYear] = useState(
    location?.state?.year || sessionStorage.getItem('year')
  );
  const [ignoreHoliday, setIgnoreHoliday] = useState(false);
  const [filterProgram, setFilterProgram] = useState(false);
  const [previous, setPrevious] = useState({});
  const [gradeInp, setGradeInp] = useState({});
  const [dataStream, setDataStream] = useState({});
  const [accordienSecondCheck, setAccordienSecondCheck] = useState(false);
  const [accordienThirdCheck, setAccordienThirdCheck] = useState(false);
  const [accordienFourthCheck, setAccordienFourthCheck] = useState(false);
  const [newActivity, setNewActivity] = useState(false);
  const [editIndex, setEditIndex] = useState();
  const [toMode, setToMode] = useState('Online');
  const [campusOptions, setCampusOptions] = React.useState([]);
  const [courseOptions, setCourseOptions] = React.useState([]);
  const ignoreOpen = Boolean(anchorElIgnore);
  const ignoreIds = ignoreOpen ? 'simple-popover' : undefined;
  const [nextApproved, setNextApproved] = useState(true);
  const [locationData, setLocationData] = useState();
  const [selectedAcademicProgram, setSelectedAcademicProgram] = useState();
  const [weekNo, setWeekNo] = useState();
  const [disableAddActivity, setDisableAddActivity] = useState(false);
  const [programID, setProgramID] = useState('');
  const [programValue, setProgramValue] = useState({ title: '', value: '' });
  const [programPlanval, setprogramPlanval] = useState({
    title: '',
    value: '',
  });
  const [rowSubject, setRowSubject] = useState([]); // Table Row
  const [confirmDialogAddReference, setConfirmDialogAddReference] =
    useState(false);
  const [sessions, setSessions] = useState([]);
  const [facultyOptions, setFacultyOptions] = useState([]);
  const [sessionValue, setSessionValue] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [selectSubjectValue, setSelectSubjectValue] = React.useState('');
  const [allSubjects, setAllSubjects] = useState([]);
  const [sections, setSections] = useState([]);
  const [facultyName, setFacultyName] = useState('');
  const [facultyNameTwo, setFacultyNameTwo] = useState('');
  const [facultyNameThree, setFacultyNameThree] = useState('');
  const [showFilters, setShowFilters] = useState(true);
  const [programPlanIDOptions, setProgramPlanIDOptions] = useState([]);
  const [programPlanID, setProgramPlanID] = useState(
    location?.state?.batchId || ''
  );
  const [downloadDialog, setDowloadDialog] = useState(false);
  const [termCheckboxlist, setTermCheckboxlist] = useState([]);
  const [modeDownload, setModeDownload] = useState('');
  const [selectedTerm, setSelectedTerm] = useState();
  const [expanded, setExpanded] = useState(0);
  const [fetchingData, setFetchingData] = React.useState('');
  const [workingDays, setWorkingDays] = React.useState('');
  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  console.log('programName', programName);

  useEffect(() => {
    let academicProgram = sessionStorage.getItem('AcademicProgram');
    let programPlanId = sessionStorage.getItem('programPlanID');
    let ProgramPlan = sessionStorage.getItem('ProgramPlan');
    if (Object.values(props).length > 0) {
      setprogramPlanval(props.programPlanval);
      setProgramValue(props.programValue);
      setProgramPlanID(props.programPlanval.value);
      if (courseOptions.length > 0) {
        let temp = courseOptions.filter((item) => {
          return item.title === props.programValue.title;
        });
        handleAutocomplete('courseName', '', courseOptions, temp[0]);
        console.log(temp);
      }
    } else if (academicProgram && programPlanId && ProgramPlan) {
      academicProgram = JSON.parse(sessionStorage.getItem('AcademicProgram'));
      ProgramPlan = JSON.parse(sessionStorage.getItem('ProgramPlan'));
      setProgramValue(academicProgram);
      setprogramPlanval(ProgramPlan);
      setProgramPlanID(programPlanId);
      let temp = courseOptions.filter((item) => {
        return item?.title === academicProgram?.title;
      });
      handleAutocomplete('courseName', '', courseOptions, temp[0]);
    }
  }, [props, courseOptions]);
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  const onDownloadPdf = () => {
    setDowloadDialog(true);
  };

  const termCheckboxlistHandler = (e) => {
    if (e.target.checked) {
      setTermCheckboxlist([...termCheckboxlist, e.target.name]);
    } else {
      setTermCheckboxlist(
        termCheckboxlist.filter((item) => item !== e.target.name)
      );
    }
  };
  const handleDownloadermode = (e) => {
    setModeDownload(e.target.value);
  };
  const handleDownloadPdf = async () => {
    if (termCheckboxlist.length > 0) {
      if (modeDownload === 'downloadPdf') {
        const unit = 'pt';
        const size = 'A4'; // Use A1, A2, A3 or A4
        const orientation = 'portrait'; // portrait or landscape

        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(12);

        const title = ` S P Jain’s ${programName} program \n Academic Calendar for Intake – ${programName} \n \n`;
        const headers = [['Activity', 'Duration', 'Dates']];
        doc.text(title, marginLeft, 40);
        doc.line(40, 65, 580, 65, 'S');
        let lastTerm;
        if (
          ![2, 4, 6, 8, 10, 12].includes(
            parseInt(termCheckboxlist[0].split('-')[3][4])
          )
        ) {
          lastTerm = `${termCheckboxlist[0].split('-')[3]},Term${
            parseInt(termCheckboxlist[0].split('-')[3][4]) + 1
          }`;
        } else {
          lastTerm = `Term${
            parseInt(termCheckboxlist[0].split('-')[3][4]) - 1
          },${termCheckboxlist[0].split('-')[3]}`;
        }
        console.log('RROOWWSS', lastTerm);
        rows.map((item, index) => {
          // if (!lastTerm.split(',').includes(item.courseName.split('-')[3])) {
          //   lastTerm = 'Term3,Term4';
          // }

          let pdfData = [];
          const termCheckboxlistsort = termCheckboxlist.sort();
          console.log('termCheckboxlistsort', termCheckboxlist);
          if (termCheckboxlistsort.includes(item.courseName)) {
            item?.array.map((el) => {
              const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
              const firstDate = new Date(el.startDate);
              const secondDate = new Date(el.endDate);
              const durationDiff = getWeeksDiff(
                Math.round(Math.abs((firstDate - secondDate) / oneDay))
              );
              pdfData.push({
                ...el,
                duration: durationDiff,
              });
            });
            if (!lastTerm.split(',').includes(item.courseName.split('-')[3])) {
              console.log(
                "item.courseName.split('-')[3]",
                item.courseName.split('-')[3]
              );
              if (
                ![2, 4, 6, 8, 10, 12].includes(
                  parseInt(item.courseName.split('-')[3][4])
                )
              ) {
                lastTerm = `${item.courseName.split('-')[3]},Term${
                  parseInt(item.courseName.split('-')[3][4]) + 1
                }`;
              } else {
                lastTerm = `Term${
                  parseInt(item.courseName.split('-')[3][4]) - 1
                },${item.courseName.split('-')[3]}`;
              }
              console.log('lastTermlastTermlastTerm', lastTerm);

              // lastTerm = 'Term3,Term4';
              doc.addPage();
            }

            const data = pdfData.map((elt) => [
              elt.typeofActivity,
              elt.duration,
              `${
                dateFormatter(elt.startDate) + '-' + dateFormatter(elt.endDate)
              }`,
            ]);

            var finalY = doc.lastAutoTable.finalY || 40;
            let content = {
              theme: 'grid',
              startY: finalY + 60,
              head: headers,
              body: data,
            };

            doc.text(item.courseName, marginLeft, finalY + 40);
            doc.autoTable(content);
            console.log('termCheckboxlist', termCheckboxlist);
            // if ((index + 1) % 2 === 0) {
            //   doc.addPage();
            // }
            console.log("lastTerm.split(',')", lastTerm.split(','));
            console.log(
              "item.courseName.split('-')[3]",
              item.courseName.split('-')[3]
            );
            console.log(
              'CONDI',
              lastTerm.split(',').includes(item.courseName.split('-')[3])
            );

            setDowloadDialog(false);
            setTermCheckboxlist([]);
            setModeDownload('');
          }
        });
        doc.save(
          `${programName} term ${moment().format('YYYY-MM-DD_HH:mm')}.pdf`
        );
      } else if (modeDownload === 'downloadWord') {
        const title = ` S P Jain's ${programName} Program  <br /> Academic Calendar for Intake - ${programName} \n \n`;
        let tables = '';
        let lastTerm;
        if (
          ![2, 4, 6, 8, 10, 12].includes(
            parseInt(termCheckboxlist[0].split('-')[3][4])
          )
        ) {
          lastTerm = `${termCheckboxlist[0].split('-')[3]},Term${
            parseInt(termCheckboxlist[0].split('-')[3][4]) + 1
          }`;
        } else {
          lastTerm = `Term${
            parseInt(termCheckboxlist[0].split('-')[3][4]) - 1
          },${termCheckboxlist[0].split('-')[3]}`;
        }
        rows.forEach((item, index) => {
          let pdfData = [];
          if (termCheckboxlist.includes(item.courseName)) {
            item?.array.map((el) => {
              const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
              const firstDate = new Date(el.startDate);
              const secondDate = new Date(el.endDate);
              const durationDiff = getWeeksDiff(
                Math.round(Math.abs((firstDate - secondDate) / oneDay))
              );
              pdfData.push({
                ...el,
                duration: durationDiff,
              });
            });

            const data = pdfData.map((elem) => ({
              country: elem.typeofActivity,
              duration: elem.duration,
              startdate: `${
                dateFormatter(elem.startDate) +
                ' - ' +
                dateFormatter(elem.endDate)
              }`,
            }));
            if (!lastTerm.split(',').includes(item.courseName.split('-')[3])) {
              if (
                ![2, 4, 6, 8, 10, 12].includes(
                  parseInt(item.courseName.split('-')[3][4])
                )
              ) {
                lastTerm = `${item.courseName.split('-')[3]},Term${
                  parseInt(item.courseName.split('-')[3][4]) + 1
                }`;
              } else {
                lastTerm = `Term${
                  parseInt(item.courseName.split('-')[3][4]) - 1
                },${item.courseName.split('-')[3]}`;
              }
              tables += `<div class="page-break" style="page-break-after: always;"></div>`;
            }
            tables += `
            <h3>${item.courseName}</h3>
            <table>
            <thead>
                <tr>
                  <th>Activity</th>
                  <th>Duration</th>
                  <th>Dates</th>
                </tr>
              </thead>
              <tbody>`;
            data.map((items) => {
              console.log('itemsitemsitems', items);
              return (tables += `<tr>
                  <td>${items.country}</td>
                  <td>${items.duration}</td>
                  <td>${items.startdate}</td>
                </tr>`);
            });
            tables += `</tbody></table>`;
          }
        });
        console.log('tableContent', tables);
        const content = `<!DOCTYPE html>
        <html lang="en">
        <style>
        table{width: 100%},
        table,
        th,
        td {
          border: 1px solid black;
          border-collapse: collapse;
          text-align: 'center'
        }
      </style>
          <body>
            <div>
            <h3 style="border-bottom: #000000;">${title}</h3>
            <hr/>
            <br />
            ${tables}
            </div>
          </body>
        </html>`;
        // console.log('contentcontentcontent', content);
        // const data = await HTMLtoDOCX(content);
        // console.log('data', data);
        // saveAs(
        //   data,
        //   `${programName} term ${moment().format('YYYY-MM-DD_HH:mm')}.docx`
        // );
        // setDowloadDialog(false);
        // setTermCheckboxlist([]);
        // setModeDownload('');
        asBlob(content).then((data) => {
          saveAs(
            data,
            `${programName} term ${moment().format('YYYY-MM-DD_HH:mm')}.docx`
          );
        });
      } else if (modeDownload === '') {
        handleSnackbarOpen('error', 'Please select mode of download');
      }
    } else {
      handleSnackbarOpen('error', 'Please select atleast one term');
    }
  };

  useEffect(async () => {
    // const bookedSlot = await getBookedSlot(); // Facility Booking Get API on Booked Slots

    const faciltiyAndFacultyData = await getFacultyAndFacilty();

    const AllFacultyObject = Object.values(faciltiyAndFacultyData.Faculty);
    const facilitys = Object.values(faciltiyAndFacultyData?.Facility);
    const activityData = Object.values(faciltiyAndFacultyData?.Activity);
    const activitySession = activityData.map((e) => {
      return { label: e.label, value: e.value };
    });
    setSessions(activitySession);
    const AllfacultyData = AllFacultyObject.map((fData) => {
      return { label: fData.facultyName, value: fData.id };
    });
    setFacultyOptions(AllfacultyData);

    // all subjects fetch
    // const versionData = await getCourseVersion(term);
    // setAllSubjects(versionData);
    // const versionDataConvert = Object.values(versionData);
    // const subjectName = versionDataConvert[0]?.map((data) => {
    //   return { label: data.courseName, value: data.id };
    // });
    // // const newSubjectName = [...subjectName, { label: '--', value: '' }];
    // setSubjects(subjectName);
  }, []);
  // const handleSnackbarClose = (event, reason) => {
  //   if (reason === 'clickaway') return;
  //   setOpenSnackbar(false);
  // };

  // const handleSnackbarOpen = (severity, message) => {
  //   setOpenSnackbar(true);
  //   setSnackbarSeverity(severity);
  //   setSnackbarMessage(message);
  // };
  const handleSelectProgramChange = (e, value) => {
    setSessionValue(e.target.value);
  };

  const handleChangedStartDate = (e) => {
    setStartDate(e.target.value);
  };
  const handleChangedEndDated = (e) => {
    setEndDate(e.target.value);
  };
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleSelectFacultyChange = (e, value) => {
    setFacultyName(e.target.value);
  };

  const handleSelectFacultyTwoChange = (e, value) => {
    setFacultyNameTwo(e.target.value);
  };

  const handleSelectFacultyThreeChange = (e, value) => {
    setFacultyNameThree(e.target.value);
  };
  const handleToModeChange = (event) => {
    setToMode(event.target.value);
  };
  const onToggleEdit = (id, rowes) => {
    setRows((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };

  const handleInputChange = (e) => {
    console.log('e.target', e.target);
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const onRevert = (id, rows, index) => {
    const newData = [...rows];
    newData[index].array.map((row) => {
      // if (row.id === id) {
      if (row.academicCalenderId === id) {
        return (row.isEditMode = false);
      }
    });
    setRows(newData);
    setDisableAddActivity(false);
  };

  const handleSelectChangeSubject = (event) => {
    dataStream.activity = event.target.value;
    setSelectValueSubject(event.target.value);
  };
  const handleChangedCredit = (event) => {
    dataStream.durationInWeeks = event.target.value;
  };
  const handleChangedDate = (event) => {
    dataStream.startDate = event.target.value;
  };
  const handleChangedEndDate = (event) => {
    dataStream.endDate = event.target.value;
  };
  const dateFormatter = (date) => {
    let dArr = date.split('-');
    return dArr[2] + '/' + dArr[1] + '/' + dArr[0];
  };
  const handlePopoverOpen = (event) => {
    setAnchorEls(event.currentTarget);
  };

  const handleSelectSubjectChange = (e) => {
    console.log('handleSelectSubjectChange');
    setSelectSubjectValue(e.target.value);
    const subjectData = Object.values(allSubjects);
    const sectionData = subjectData[0]?.filter(
      (ele) => ele.id == e.target.value
    );
    const sectionDropdown =
      subjectData &&
      subjectData.length > 0 &&
      sectionData[0]?.courseOffering?.map((dataEle) => {
        return { label: dataEle.courseSectionId, value: dataEle.id };
      });
    setSections(sectionDropdown);
  };
  const [rows, setRows] = useState([]);
  const [durationError, setdurationError] = useState([]);

  const [rowSecond, setRowSecond] = useState([]);

  const onToggleEditMode = (check, id, index) => {
    const newData = [...rows];
    console.log('newData', newData);
    newData[index]?.array.forEach((row) => {
      if (row.academicCalenderId === id) {
        row.isEditMode = true;
        if (check === 'done') {
          setLoading(true);
          // const payload = {
          //   AcademicPlannerActivity: {
          //     termName: newData[index].courseName,
          //     academicPlannerActivityId: row.id,
          //     // activityDuration: row.durationInWeeks,
          //     academicPlannerActivityName: row.activity,
          //     activityStartDate: dateFormatter(row.startDate),
          //     activityEndDate: dateFormatter(row.endDate),
          //   },
          // };
          const payload = [
            {
              weekNumber: row?.weekNumber,
              typeofActivity: row.typeofActivity,
              termId: row.termId,
              startDate: `${row.startDate}T00:00:00.000Z`,
              endDate: `${row.endDate}T00:00:00.000Z`,
              academicCalenderName: `${programName} ${year} ${intake} ${term}`,
              academicCalenderId: row.academicCalenderId,
            },
          ];
          postAcademicCalendar(payload)
            .then((res) => {
              setLoading(false);
              handleSnackbarOpen('success', res.message);
              row.isEditMode = false;
              setRows(newData);
              setDisableAddActivity(false);
              console.log('newDat', newData);
            })
            .catch((err) => {
              handleSnackbarOpen('error', 'Failed to add. Please try again.');
              setLoading(false);
              row.isEditMode = false;
              setRows(newData);
              console.log('newDat', newData);
              setDisableAddActivity(false);
            });
        } else if (check === 'edit') {
          setDisableAddActivity(true);
          row.isEditMode = true;
          setRows(newData);
        }
      }
    });
    setEditIndex(index);
  };
  const onChange = (e, row) => {
    if (!previous[row.academicCalenderId]) {
      setPrevious((state) => ({ ...state, [row.academicCalenderId]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { academicCalenderId } = row;
    const newData = [...rows];
    newData[editIndex]?.array.forEach((row) => {
      if (row.academicCalenderId === academicCalenderId) {
        row[name] = value;
        if (name === 'startDate' && value != '') {
          let currentDate = moment(value);
          let termStartDate = moment([row?.termStartDate]);
          let weekNo = currentDate.diff(termStartDate, 'week');
          row['weekNumber'] = weekNo;
        }
      }
    });
    setRows(newData);
  };
  const handleRefereceCreate = (check, elem, index) => {
    if (elem?.termStartDate != null && elem?.termEndDate != null) {
      setSelectedTerm(elem);
      setConfirmDialogAddReference(true);
    } else {
      handleSnackbarOpen(
        'info',
        'Please add Term Duration, Start Date and End Date'
      );
    }
  };
  const handleSubject = (check, id, index) => {
    setDisableAddActivity(true);
    if (check == 'save') {
      setLoading(true);
      let savedData = dataStream;
      let termName = id[index].courseName;
      const payload = {
        AcademicPlannerActivity: {
          termName: termName,
          academicPlannerActivityId: null,
          // activityDuration: savedData.durationInWeeks,
          academicPlannerActivityName: savedData.activity,
          activityStartDate: dateFormatter(savedData.startDate),
          activityEndDate: dateFormatter(savedData.endDate),
        },
      };
      postAcademicPlanner(payload)
        .then((res) => {
          console.log('res', res);
          id[index].array.forEach((item) => {
            item.isEditMode = false;
          });
          setNewActivity(!newActivity);
          setLoading(false);
          setDisableAddActivity(false);
        })
        .catch((err) => {
          setLoading(false);
          handleSnackbarOpen('error', 'Failed to add. Please try again.');
          setDisableAddActivity(false);
        });
    } else {
      const newData = [...rows];
      newData[index]?.array.push(
        createData(
          `rows${rows[index]?.array.length}`,
          <p>{weekNo}</p>,
          <KenSelectWrap
            label="Activity"
            options={selectOptionsSubject}
            value={dataStream.activity}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChangeSubject}
            required
          />,
          <KenInputField
            label="Duration"
            value={dataStream.durationInWeeks}
            dropdownColor="#FFFFFF"
            onChange={handleChangedCredit}
            required
          />,
          <KenDateTimePicker
            name={'startDate'}
            label="Start Date"
            value={dataStream.startDate}
            type="date"
            required={true}
            // defaultValue={startData}
            onChange={(e) => handleChangedDate(e)}
          />,
          <KenDateTimePicker
            name={'endDate'}
            label="End Date"
            value={dataStream.endDate}
            type="date"
            required={true}
            // defaultValue={startData}
            onChange={(e) => handleChangedEndDate(e)}
          />,
          true
        )
      );
      setRows(newData);
    }
  };
  const handlePopoverClose = () => {
    setAnchorEls(null);
  };
  React.useEffect(() => {
    setLoading(true);
    let locationData = history?.location?.state?.batchName;
    setLocationData(locationData);
    getAcademicFilter()
      .then((res) => {
        let courseOptions = [];
        let campusOptions = [];
        Object.entries(res['Academic Program']).map(([item, keyVal]) => {
          courseOptions.push({
            label: item,
            value: item,
            id: keyVal.id,
            terms: JSON.parse(keyVal.terms),
          });
        });
        const array = Object.entries(res['Academic Program']).map(
          ([item, keyVal]) => {
            return {
              title: item,
              value: item,
              id: keyVal.id,
              terms: JSON.parse(keyVal.terms),
            };
          }
        );

        console.log('array', array);
        Object.entries(res['Campus']).map(([item, keyVal]) => {
          campusOptions.push({ label: item, value: item });
        });
        setCourseOptions(array);
        setCampusOptions(campusOptions);
        if (locationData != undefined) {
          setProgramName(locationData);
          let e = { target: { name: 'program', value: locationData } };
          handleFilter(e, courseOptions);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  React.useEffect(() => {
    getAcademicCalendarData();
  }, [programID, programPlanID]);

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('tId')) {
      setTerm(params.get('tId'));
      setShowFilters(false);
    }
  }, []);

  const getAcademicCalendarData = () => {
    setLoading(true);
    if (programID != undefined && programPlanID != undefined) {
      setNextApproved(false);
      setDisableMaster(false);
    }
    let querry = `?programPlanId=${programPlanID}&academicId=${programID}`;
    // getAcademicPlannerData(data)
    getAcademicCalendarNew(querry)
      .then((res) => {
        let responseData = res?.message;
        if (
          responseData === 'No Data Found' ||
          responseData === 'Invalid Parameters'
        ) {
          setRows([]);
        } else {
          console.log('resssssssssssssssssssssssssss', res);
          let values = Object.values(res);
          let alteredData = values.map((item) => {
            let sortName = item.termName.split('-');
            let currentTerm = sortName[3];
            console.log('sortName', sortName);
            console.log('enddate');
            setWorkingDays(item.workingDays);
            return {
              courseName: item.termName,
              courseId: item.termId,
              currentTerm: currentTerm,
              termStartDate: item.termStartDate,
              termId: item.termId,
              termDuration: item.termDuration,
              termMinStart: checkMinDate(item.batch, item.intake),
              termEndDate:
                item.termDuration === null
                  ? moment(item?.termStartDate, 'YYYY-MM-DD;HH:mm:ss')
                      .add(
                        item?.termDuration != null ? item?.termDuration : 0,
                        'weeks'
                      )
                      .format('YYYY-MM-DD')
                  : item.termEndDate,
              array: [...item.academicCalenders],
              workingDays: item.workingDays,
            };
          });
          const errorTerm = values.map((item) => {
            return {
              termDuration: '',
            };
          });
          setdurationError(errorTerm);
          alteredData.sort((a, b) => {
            if (a.currentTerm < b.currentTerm) {
              return -1;
            }
            if (a.currentTerm > b.currentTerm) {
              return 1;
            }
            return 0;
          });
          console.log('alteredDataVal', alteredData);
          setRows(alteredData);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const checkMinDate = (batch, intake) => {
    let months = [
      { label: 'JAN', month: '01' },
      { label: 'FEB', month: '02' },
      { label: 'MAR', month: '03' },
      { label: 'APR', month: '04' },
      { label: 'MAY', month: '05' },
      { label: 'JUN', month: '06' },
      { label: 'JUL', month: '07' },
      { label: 'AUG', month: '08' },
      { label: 'SEP', month: '09' },
      { label: 'OCT', month: '10' },
      { label: 'NOV', month: '11' },
      { label: 'DEC', month: '12' },
    ];
    let selectedMonth = months.filter((item) => item.label === intake)[0].month;
    let newStartMonth = `${batch}-${selectedMonth}-01`;
    return newStartMonth;
  };

  const opens = Boolean(anchorEls);
  const ids = opens ? 'simple-popover' : undefined;
  const manageStartDate = (e) => {
    setStartDate(e.target.value);
  };
  const manageEndDate = (e) => {
    setEndDate(e.target.value);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleSelectChange = (e) => {
    setSelectValue(e.target.value);
  };
  const handleSelectOptionChange = (e) => {
    setSelectSectionValue(e.target.value);
  };

  // const handleFilter = (e, data) => {
  //   const { name, value } = e.target;
  //   setFilters({
  //     ...filters,
  //     [name]: value,
  //   });
  //   if (e.target.name === 'program') {
  //     setProgramName(value);
  //     let newData = data.filter((element) => {
  //       return element.label === e.target.value;
  //     });
  //     let termData = [];
  //     newData[0]?.terms.map((item) => {
  //       termData.push({ label: item.name, value: item.name });
  //     });
  //     termData.push({ label: 'All', value: 'All' });
  //     setSelectedAcademicProgram(newData);
  //     setProgramID(newData[0]?.id);
  //     // setTermDropdown(termData);
  //     setTermOptions(termData);
  //     // setTerm(undefined);
  //   } else if (name === 'intake') {
  //     setIntake(value);
  //   } else if (name === 'term') {
  //     setTerm(value);
  //   }
  // };
  const handleAutocomplete = (name, e, data, objValue) => {
    console.log('ttt', objValue);
    if (name == 'courseName') {
      if (objValue != null) {
        setFilters({
          ...filters,
          [name]: objValue?.title,
        });
        setRowSubject([]);
        setFetchingData('');
        setProgramName(objValue?.title);
        let newData = objValue;
        setProgramID(newData?.id);
        setProgramValue({
          title: newData?.title,
          value: newData?.value,
        });
        sessionStorage.setItem(
          'AcademicProgram',
          JSON.stringify({ title: newData?.title, value: newData?.value })
        );
        let termData = [];
        newData?.terms.map((item) => {
          termData.push({ title: item.name, value: item.name });
        });
        termData.push({ title: 'All', value: 'All' });
        setTermDropdown(termData);
        setTerm(undefined);
      } else {
        setFilters({ ...filters, [name]: '' });
        setProgramName('');
        setProgramID('');
        setProgramValue({ title: '', value: '' });
        setTermDropdown([]);
        setprogramPlanval({ title: '', value: '' });
        setProgramPlanIDOptions([]);
        setFetchingData('');
      }
    } else if (name == 'ProgramPlan') {
      if (objValue != null) {
        setFilters({
          ...filters,
          [name]: objValue?.value,
        });
        setFetchingData('Fetching Data...');
        setProgramPlanID(objValue?.value);
        setprogramPlanval({
          title: objValue.title,
          value: objValue.value,
        });
        sessionStorage.setItem(
          'ProgramPlan',
          JSON.stringify({ title: objValue.title, value: objValue.value })
        );
        sessionStorage.setItem('programPlanID', objValue?.value);
        setDisableMaster(false);
      } else {
        setFilters({ ...filters, [name]: '' });
        setProgramPlanID('');
        setFetchingData('');
        setprogramPlanval({ title: '', value: '' });
        setDisableMaster(false);
      }
    }
  };

  const handleFilter = (e, data) => {
    const { name, value, id } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
    // if (e.target.name === 'courseName') {
    //   setRowSubject([]);
    //   setFetchingData('');
    //   // sessionStorage.setItem('programName', value);
    //   setProgramName(value);
    //   let newData = data.filter((element) => {
    //     return element.label === e.target.value;
    //   });
    //   setProgramID(newData[0]?.id);
    //   // sessionStorage.setItem('programID', newData[0]?.id);
    //   let termData = [];
    //   newData[0]?.terms.map((item) => {
    //     termData.push({ label: item.name, value: item.name });
    //   });
    //   termData.push({ label: 'All', value: 'All' });
    //   // setProgramID(newData[0].id)
    //   setTermDropdown(termData);
    //   setTerm(undefined);
    // } else
    if (e.target.name === 'intake') {
      sessionStorage.setItem('intake', value);
      setIntake(value);
    } else if (e.target.name === 'year') {
      sessionStorage.setItem('year', value);
      setYear(value);
    }
    // else if (e.target.name === 'ProgramPlan') {
    //   setFetchingData('Fetching Data...');
    //   setProgramPlanID(value);
    //   setDisableMaster(false);
    // }
  };
  const handleSelectChange2 = () => {
    setProgramValue({
      title: '',
      value: '',
    });
    setprogramPlanval({
      title: '',
      value: '',
    });
    setFetchingData('');
    setProgramID('');
    setProgramPlanID('');
    setRows([]);
    setProgramPlanIDOptions([]);
    sessionStorage.setItem('ProgramPlan', '');
    sessionStorage.setItem('AcademicProgram', '');
    sessionStorage.setItem('programPlanID', '');
    getAcademicCalendarData();
  };

  function handleIgnoreHolidayDialog() {
    setIgnoreHoliday((prevState) => !prevState);
  }
  function handleFilterProgramDialog() {
    setFilterProgram((prevState) => !prevState);
  }
  function handleDowloadDialog() {
    setFilterProgram((prevState) => !prevState);
  }

  const handleCancel = (row, rows, index) => {
    setDisableAddActivity(false);
    const newData = [...rows];
    newData[index].array.pop((item) => item.id === row);
    setRows(newData);
  };
  function handleCloneDialog() {
    setCloneDialog((prevState) => !prevState);
  }

  // GET PROGRAM PLAN ID
  React.useEffect(() => {
    setLoading(true);
    const data = JSON.parse(userDetails);
    const instituteId = data?.Id;
    if (programID != '') {
      getDataForCourseEnrolment(instituteId)
        .then((res) => {
          let programPlanData = Object.entries(
            res?.ProgramPlanForEachAcedemicProgram
          ).filter((item) => {
            if (item[0] === programID) {
              return item;
            }
          });
          if (programPlanData.length > 0) {
            let programPlanIDOptions = [];
            programPlanData[0][1].map((items) => {
              programPlanIDOptions.push({
                title: items.ProgramPlanName,
                value: items.ProgramPlanId,
              });
            });
            setProgramPlanIDOptions(programPlanIDOptions);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, [programID]);

  const masterImportDialog = () => {
    setMasterDialog(true);
    setLoading(false);
    if (!masterDialog) {
      setLoading(true);
      let querry = `?academicProgramId=${selectedAcademicProgram[0]?.id}`;
      getMasterActivityWithTermData(querry)
        .then((res) => {
          console.log(res);
          let responseData = res?.message;
          if (responseData === 'No Data Found') {
            setMasterData([]);
          } else {
            let key = Object.keys(res);
            let values = Object.values(res);
            let alteredData = key.map((el, ind) => {
              return {
                courseName: el,
                array: [...values[ind]],
              };
            });
            console.log(alteredData, 'alteredData');
            setMasterData(alteredData);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };
  const masterImportCancel = () => {
    setMasterData([]);
    setMasterDialog(false);
  };
  const masterImportSubmit = () => {
    setLoading(true);
    const data = `?academicProgramId=${selectedAcademicProgram[0]?.id}&intake=${intake}&year=${year}`;
    getImportTermActivity(data)
      .then((res) => {
        handleSnackbarOpen('success', res.message);
        setLoading(false);
        setMasterImportSuccess(!masterImportSuccess);
        setMasterDialog(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const termStartDate = (e, item, index) => {
    const rowsData = [...rows];
    if (item.termDuration != null) {
      setRows((state) => {
        return rowsData.map((row) => {
          if (row.courseName === item.courseName) {
            let currentEndDay = moment(e.target.value)
              .add(item.termDuration, 'weeks')
              .format('dddd');
            console.log(
              'Orignal End Date',
              moment(e.target.value, 'YYYY-MM-DD;HH:mm:ss')
                .add(item.termDuration, 'weeks')
                .format('YYYY-MM-DD')
            );
            let defaultDays =
              'Monday;Tuesday;Wednesday;Thursday;Friday;Saturday;Sunday';
            let selected =
              item?.workingDays != null
                ? item?.workingDays.split(';')
                : defaultDays.split(';');
            if (selected.includes(currentEndDay)) {
              let termStartDate = e.target.value;
              let termEndDate = moment(e.target.value, 'YYYY-MM-DD;HH:mm:ss')
                .add(item.termDuration, 'weeks')
                .format('YYYY-MM-DD');
              handleTermDateChange(termStartDate, termEndDate, item);
              return {
                ...row,
                termStartDate: termStartDate,
                termEndDate: termEndDate,
              };
            } else {
              let nextDay;
              let daysAdded;
              let updatedDate;
              let m1 = moment(e.target.value, 'YYYY-MM-DD;HH:mm:ss')
                .add(item.termDuration, 'weeks')
                .format('YYYY-MM-DD');
              let convertedDays = selected.map((item2) => {
                return moment().day(item2).weekday();
              });
              const currentDayInt = moment().day(currentEndDay).weekday();
              const intCheck = convertedDays.some((val) => {
                return val > currentDayInt;
              });
              if (intCheck) {
                nextDay = convertedDays.filter((val) => {
                  return val > currentDayInt;
                })[0];
              } else {
                nextDay = Math.min(...convertedDays);
              }
              if (currentDayInt <= nextDay) {
                daysAdded = nextDay - currentDayInt;
                updatedDate = moment(m1).add(daysAdded, 'days');
              } else {
                daysAdded = Number(7) - currentDayInt + nextDay;
                updatedDate = moment(m1).add(daysAdded, 'days');
              }
              console.log('Updated End Date', updatedDate.format('YYYY-MM-DD'));
              let termStartDate = e.target.value;
              let termEndDate = updatedDate.format('YYYY-MM-DD');
              handleTermDateChange(termStartDate, termEndDate, item);
              return {
                ...row,
                termStartDate: e.target.value,
                termEndDate: updatedDate.format('YYYY-MM-DD'),
              };
            }
          }
          return row;
        });
      });
    } else {
      handleSnackbarOpen('info', 'Enter Term Duration');
    }
  };
  const termEndDate = (e, item, index) => {
    const rowsData = [...rows];
    setRows((state) => {
      return rowsData.map((row) => {
        if (row.courseName === item.courseName) {
          return { ...row, termEndDate: e.target.value };
        }
        return row;
      });
    });
  };
  const termDurationChange = (e, elem, index) => {
    const value = e.target.value;
    let data = [...durationError];
    var numbers = /^[0-9]+$/;
    if (value.match(numbers)) {
      data[index]['termDuration'] = '';
    } else {
      data[index]['termDuration'] = 'Please enter vaild duration';
    }
    if (elem.termStartDate != null) {
      elem.termEndDate = moment(elem.termStartDate, 'YYYY-MM-DD;HH:mm:ss')
        .add(value, 'weeks')
        .format('YYYY-MM-DD');
    }
    elem.termDuration = value;
    if (value === '') {
      elem.termEndDate = null;
      elem.termDuration = null;
      data[index]['termDuration'] = '';
    }
    setdurationError(data);
    return elem;
  };
  const postTermChange = (elem) => {
    setLoading(true);
    let payload = [
      {
        termId: elem.termId,
        startDate: elem.termStartDate,
        endDate: elem.termEndDate,
        termDuration: elem.termDuration,
      },
    ];
    postTermDatesUpdate(payload)
      .then((res) => {
        setLoading(false);
        handleSnackbarOpen('success', res.message);
        getAcademicCalendarData();
      })
      .catch((err) => {
        setLoading(false);
        handleSnackbarOpen('error', err.message);
      });
  };
  const handleTermDateChange = (termStart, termEnd, item) => {
    setLoading(true);
    let payload = [
      {
        termId: item.termId,
        startDate: termStart,
        endDate: termEnd,
        termDuration: item.termDuration,
      },
    ];
    postTermDatesUpdate(payload)
      .then((res) => {
        setLoading(false);
        handleSnackbarOpen('success', res.message);
        getAcademicCalendarData();
      })
      .catch((err) => {
        setLoading(false);
        handleSnackbarOpen('error', err.message);
      });
  };
  const handleFilterTerm = async (e, v) => {
    sessionStorage.setItem('term', e.target.value);
    sessionStorage.setItem('termValue', v.props.children[1]);
    setTerm(e.target.value);
    const versionData = await getCourseVersion(term);
    setAllSubjects(versionData);
    const versionDataConvert = Object.values(versionData);
    const subjectName = versionDataConvert[0]?.map((data) => {
      return { label: data.courseName, value: data.id };
    });
    const newSubjectName = [...subjectName, { label: '--', value: '' }];
    setSubjects(newSubjectName);
  };

  useEffect(async () => {
    let terms = [];
    if (programName && year && intake) {
      let program = programName;
      const termDatas = await getTermData({ program, year, intake });
      if (termDatas.length > 0) {
        terms = termDatas.map((ele) => {
          return { label: ele.Semester, value: ele.TermRecordId };
        });
        console.log('terms', terms);
        setTermOptions(terms);
      } else {
        setTerm('');
        setTermOptions([]);
        setSubjects([]);
        setSelectSubjectValue('');
      }
    }
  }, [programName, year, intake]);

  const closeAddReference = () => {
    setConfirmDialogAddReference(false);
    getAcademicCalendarData();
  };

  const getWeeksDiff = (days) => {
    // let months = parseInt(days / 30);
    // days = days - months * 30;
    let weeks = parseInt(days / 7);
    days = days - weeks * 7;
    return (
      (weeks > 0 ? weeks + ' week' + (weeks > 1 ? 's ' : ', ') : '') +
      (days > 0 ? days + ' day' + (days > 1 ? 's ' : '') : '')
    );
  };
  function getWeeksDiffererce(startDate, endDate) {
    const msInWeek = 1000 * 60 * 60 * 24 * 7;

    return Math.round(Math.abs(endDate - startDate) / msInWeek);
  }
  return (
    <Box style={{ width: '100%' }}>
      {loading && <KenLoader />}
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      {!Object.values(props).length > 0 ? (
        <AppBar position="static" elevation={0} className={classes.header}>
          <Toolbar>
            <Grid container xs={12}>
              <Grid item xs={12} md={6}>
                <Typography variant="h6" className={classes.title}>
                  Academic Calendar
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} className={classes.goBack}>
                <Button
                  variant="secondary"
                  color="primary"
                  style={{ marginRight: '10px', border: '1px solid #272727' }}
                  onClick={() => {
                    history.push({
                      pathname: `${routes.currentProgrammes}`,
                    });
                  }}
                >
                  <ArrowBack />
                  Current Batches
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    history.push({
                      pathname: `${routes.addSubject}`,
                    });
                  }}
                >
                  Add Subjects
                  <ArrowForward />
                </Button>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      ) : null}
      {/* FILTERS */}
      {/* {showFilters&&
      <Box mt={2} mb={2} className={classes.sortingSection}>
        <KenSelect
          name="program"
          label="Academic Program *"
          options={courseOptions}
          value={programName}
          dropdownColor="#ffffff"
          onChange={(el) => handleFilter(el, courseOptions)}
          required={true}
        />
        <KenSelect
          label="Year *"
          options={yearOptions}
          value={year}
          dropdownColor="#ffffff"
          onChange={(e) => setYear(e.target.value)}
          required={true}
        />
        <KenSelectWrap
          name="intake"
          label="Intake *"
          options={intakeOptions}
          value={intake}
          dropdownColor="#FFFFFF"
          onChange={(el) => handleFilter(el, intakeOptions)}
          required
        />
        <KenSelectWrap
          name="term"
          label="Term"
          options={termOptions}
          value={term}
          dropdownColor="#FFFFFF"
          onChange={(el) => handleFilter(el, termOptions)}
          required
        />
      </Box>} */}

      {showFilters && (
        <Grid container xs={12} style={{ margin: '10px 0px' }}>
          <Grid container xs={6}>
            <Grid container xs={4} style={{ marginRight: 10 }}>
              {/* <KenSelect
                name="courseName"
                label="Academic Program *"
                options={courseOptions}
                value={programName}
                dropdownColor="#ffffff"
                onChange={(el) => handleFilter(el, courseOptions)}
                required={true}
              /> */}
              <div className="accal">
                <KenAutoComplete
                  name="courseName"
                  options={courseOptions}
                  label="Academic Program "
                  value={programValue}
                  onChange={(el, value) =>
                    handleAutocomplete('courseName', el, courseOptions, value)
                  }
                  required={true}
                  multiple={false}
                />
              </div>
            </Grid>
            <Grid container xs={4} style={{ marginRight: 10 }}>
              <div className="accal">
                <KenAutoComplete
                  name="ProgramPlan"
                  label="Program Plan"
                  options={programPlanIDOptions}
                  value={programPlanval}
                  dropdownColor="#ffffff"
                  onChange={(el, value) =>
                    handleAutocomplete(
                      'ProgramPlan',
                      el,
                      programPlanIDOptions,
                      value
                    )
                  }
                  required={true}
                  multiple={false}
                />
              </div>
            </Grid>
            <Button
              variant="contained"
              color="primary"
              className={classes.addButton}
              onClick={handleSelectChange2}
            >
              Clear All
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Grid container xs={12} style={{ flexFlow: 'row' }}>
              <Grid
                item
                xs={9}
                style={{
                  transform: 'translateY(25%)',
                  wordBreak: 'break-word',
                }}
              >
                {workingDays ? (
                  <p>
                    <b>Working Days: </b>
                    {workingDays}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={3}>
                {rows.length > 0 ? (
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{
                      marginRight: '16px',
                      marginTop: '15px',
                      float: 'right',
                    }}
                    onClick={() => onDownloadPdf(rows)}
                    disabled={disableAddActivity}
                  >
                    Download
                  </Button>
                ) : null}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      {/* TERM DATA */}
      {rows.length > 0 ? (
        rows.map((elem, index) => {
          console.log('durationError', elem);
          return (
            <Box className="cardlsitbox" style={{ marginBottom: '20px' }}>
              <Accordion
                expanded={expanded === index && accordienCheck ? true : false}
              >
                <AccordionSummary expandIcon={accordienCheck}>
                  {expanded === index && accordienCheck ? (
                    <AiOutlineMinusSquare
                      size={20}
                      onClick={() => {
                        setExpanded(index);
                        setAccordienCheck(!accordienCheck);
                      }}
                    />
                  ) : (
                    <AiOutlinePlusSquare
                      size={20}
                      onClick={() => {
                        setExpanded(index);
                        setAccordienCheck(!accordienCheck);
                      }}
                    />
                  )}{' '}
                  &nbsp;{' '}
                  <Grid item xs={5}>
                    <span style={{ color: '#092682', font: 'Open Sans' }}>
                      {elem.courseName}
                    </span>
                  </Grid>
                  <Grid container xs={7}>
                    {accordienCheck ? (
                      <div
                        style={{
                          display: 'flex',
                          position: 'absolute',
                          right: 0,
                          top: 8,
                        }}
                      >
                        <div
                          style={{ marginRight: '12px' }}
                          className="term-duration-input"
                        >
                          <KenInputField
                            label="Term duration(in weeks)"
                            required
                            className="weekNo-input"
                            name="termDuration"
                            onChange={(e) => termDurationChange(e, elem, index)}
                            value={elem.termDuration}
                            disablePtag={true}
                          />
                          <p style={{ color: 'red' }}>
                            {durationError?.[index]?.termDuration !==
                              undefined && durationError?.[index]?.termDuration}
                          </p>
                        </div>
                        <div style={{ marginRight: '12px' }}>
                          <KenDateTimePicker
                            name={'startDate'}
                            value={elem.termStartDate}
                            minDate={elem.termMinStart}
                            label="Start date"
                            type="date"
                            required={true}
                            disabled={elem.termDuration === null ? true : false}
                            onChange={(e) => termStartDate(e, elem, index)}
                          />
                        </div>
                        <div style={{ marginRight: '12px' }}>
                          <KenDateTimePicker
                            name={'endDate'}
                            label="End date"
                            value={elem.termEndDate}
                            minDate={elem.termStartDate}
                            type="date"
                            required={true}
                            disabled={elem.termDuration === null ? true : false}
                            onChange={(e) => termEndDate(e, elem, index)}
                          />
                        </div>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          style={{ marginTop: '12px' }}
                          onClick={() =>
                            handleRefereceCreate('add', elem, index)
                          }
                          disabled={disableAddActivity}
                        >
                          Add Activity
                        </Button>
                      </div>
                    ) : null}
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  {/* <KenCard elevation={0}> */}
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Week No.</TableCell>
                          <TableCell align="left">Activity</TableCell>
                          <TableCell align="left">Activity Duration</TableCell>
                          {/* <TableCell align="left">Subject</TableCell>
                          <TableCell align="left">Faculty</TableCell> */}
                          <TableCell align="left">Start Date</TableCell>
                          <TableCell align="left">End Date</TableCell>

                          <TableCell align="center">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {elem?.array?.length > 0 ? (
                          [...elem.array]
                            .sort((a, b) => a.weekNumber - b.weekNumber)
                            .map((row) => {
                              row.activityDuration = getWeeksDiffererce(
                                new Date(row.startDate),
                                new Date(row.endDate)
                              );
                              console.log('rowrowrowrow', row);
                              return (
                                // <TableRow key={row.id}>
                                <TableRow key={row.academicCalenderId}>
                                  <KenGridEditable
                                    {...{
                                      row,
                                      onChange,
                                      columns: [
                                        {
                                          column_name: 'weekNumber',
                                          is_inline_edit: false,
                                          inline_edit_type: '',
                                          label: 'Week No. ',
                                        },
                                        {
                                          column_name: 'typeofActivity',
                                          is_inline_edit: false,
                                          inline_edit_type: 'kenSelect',
                                          dropdown: sessions,
                                          label: 'Activity',
                                        },
                                        {
                                          column_name: 'activityDuration',
                                          is_inline_edit: false,
                                          inline_edit_type: '',
                                          label: 'Activity Duration',
                                        },
                                        // {
                                        //   column_name: 'subject',
                                        //   is_inline_edit: false,
                                        //   inline_edit_type: 'kenInput',
                                        //   label: 'Subject',
                                        // },
                                        // {
                                        //   column_name: 'faculty',
                                        //   is_inline_edit: false,
                                        //   inline_edit_type: '',
                                        //   label: 'Faculty',
                                        // },
                                        {
                                          column_name: 'startDate',
                                          is_inline_edit: false,
                                          inline_edit_type: 'kenDatePicker',
                                          label: 'Start Date',
                                        },
                                        {
                                          column_name: 'endDate',
                                          is_inline_edit: false,
                                          inline_edit_type: 'kenDatePicker',
                                          label: 'End Date',
                                        },
                                      ],
                                    }}
                                  />
                                  <TableCell
                                    className={classes.selectTableCell}
                                    style={{ textAlign: 'center' }}
                                  >
                                    {row.isEditMode ? (
                                      <>
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          onClick={() =>
                                            onToggleEditMode(
                                              'done',
                                              // row.id,
                                              row.academicCalenderId,
                                              index
                                            )
                                          }
                                        >
                                          Save
                                        </Button>
                                        <IconButton
                                          aria-label="revert"
                                          onClick={() =>
                                            onRevert(
                                              row?.academicCalenderId,
                                              rows,
                                              index
                                            )
                                          }
                                        >
                                          <RevertIcon />
                                        </IconButton>
                                      </>
                                    ) : (
                                      <>
                                        {!row.saved && (
                                          <IconButton
                                            aria-label="edit"
                                            onClick={() =>
                                              onToggleEditMode(
                                                'edit',
                                                // row.id,
                                                row?.academicCalenderId,
                                                index
                                              )
                                            }
                                          >
                                            <EditIcon />
                                          </IconButton>
                                        )}
                                        {row.saved && (
                                          <>
                                            <Button
                                              variant="contained"
                                              color="primary"
                                              onClick={() =>
                                                handleSubject(
                                                  'save',
                                                  rows,
                                                  index
                                                )
                                              }
                                            >
                                              Save
                                            </Button>
                                            <IconButton
                                              aria-label="revert"
                                              onClick={() =>
                                                handleCancel(
                                                  row?.academicCalenderId,
                                                  rows,
                                                  index
                                                )
                                              }
                                            >
                                              <RevertIcon />
                                            </IconButton>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                        ) : (
                          <TableRow>
                            {' '}
                            <TableCell
                              className={classes.noDataFound}
                              colSpan={6}
                              align="center"
                            >
                              No Data
                            </TableCell>{' '}
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {/* </KenCard> */}
                </AccordionDetails>{' '}
              </Accordion>
            </Box>
          );
        })
      ) : (
        <Box className="cardlsitbox">
          <p>{fetchingData}</p>
        </Box>
      )}
      {/* Next Button */}
      {/* <div className="activityNextButton">
        {rows.length > 0 ? (
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => {
              history.push({
                pathname: `${routes.fullCalendar}`,
                state: {
                  programName: programName,
                  intake: intake,
                  year: year,
                  batchName: locationData,
                  id: programID,
                },
              });
              sessionStorage.setItem('programName', programName);
              sessionStorage.setItem('intake', intake);
              sessionStorage.setItem('year', year);
            }}
            disabled={nextApproved}
          >
            Next
          </Button>
        ) : null}
      </div> */}

      {/* Filter Button */}
      <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            FILTER
          </Typography>
        }
        open={filterProgram}
        icon={<RiCheckFill />}
        handleClose={() => handleFilterProgramDialog()}
        negativeButtonClick={() => handleFilterProgramDialog()}
        positiveButtonClick={() => handleFilterProgramDialog()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <KenSelectWrap
              label="Semester"
              options={selectOptions}
              value={selectValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label={'Start date'}
              value={startDate}
              type="date"
              required={true}
              defaultValue={startDate}
              onChange={manageStartDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label={'End date'}
              value={endDate}
              type="date"
              required={true}
              defaultValue={endDate}
              onChange={manageEndDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Select City"
              name="city"
              options={campusOptions}
              value={filters?.city}
              dropdownColor="#FFFFFF"
              onChange={handleFilter}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Total Section"
              options={selectOptionsSection}
              value={selectSectionValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectOptionChange}
              required
            />
          </Grid>
        </Grid>
      </KenDialog>
      {/* Program Clone */}
      <KenDialog
        title={
          <>
            <Typography variant="h6" className={classes.dialogHeader}>
              Program Clone
            </Typography>
            {/* <CloseIcon /> */}
          </>
        }
        open={cloneDialog}
        icon={<RiCheckFill />}
        handleClose={() => handleCloneDialog()}
        negativeButtonClick={() => handleCloneDialog()}
        positiveButtonClick={() => handleCloneDialog()}
        positiveButtonText="Clone"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <span>From</span>

            <Grid item xs={12}>
              <KenSelectWrap
                name="programFrom"
                label="Program"
                options={courseOptions}
                value={formValues.programFrom}
                dropdownColor="#FFFFFF"
                onChange={(e) => handleInputChange(e)}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <KenSelectWrap
                name="intakeFrom"
                label="Intake"
                options={intakeOptions}
                value={formValues.intakeFrom}
                dropdownColor="#FFFFFF"
                onChange={(e) => handleInputChange(e)}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <KenSelectWrap
                name="courseFrom"
                label="Batch"
                options={courses}
                value={formValues.courseFrom}
                dropdownColor="#FFFFFF"
                onChange={(e) => handleInputChange(e)}
                required
              />
            </Grid>
          </Grid>
        </Grid>
      </KenDialog>
      {/* Master Term Import */}
      <KenDialog
        title={
          <>
            <Typography variant="h6" className={classes.dialogHeader}>
              Master Term Import
            </Typography>
          </>
        }
        open={masterDialog}
        icon={<RiCheckFill />}
        handleClose={() => masterImportCancel()}
        negativeButtonClick={() => masterImportCancel()}
        positiveButtonClick={() => masterImportSubmit()}
        positiveButtonText="Import"
        negativeButtonText="Cancel"
        style={{ width: '80%' }}
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {masterData.length > 0 ? (
              masterData.map((elem, index) => {
                return (
                  <Accordion expanded={masterAccordian}>
                    <AccordionSummary expandIcon={masterAccordian}>
                      {masterAccordian ? (
                        <AiOutlineMinusSquare
                          size={20}
                          onClick={() => setMasterAccordian(!masterAccordian)}
                        />
                      ) : (
                        <AiOutlinePlusSquare
                          size={20}
                          onClick={() => setMasterAccordian(!masterAccordian)}
                        />
                      )}{' '}
                      &nbsp;{' '}
                      <span style={{ color: '#092682', font: 'Open Sans' }}>
                        {elem.courseName}
                      </span>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid item xs={12}>
                        <KenGrid
                          columns={masterHead}
                          data={elem?.array}
                          pagination={{ disabled: true }}
                          toolbarDisabled={true}
                        />
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                );
              })
            ) : (
              <Accordion expanded={masterAccordian}>
                <AccordionSummary expandIcon={masterAccordian}>
                  {masterAccordian ? (
                    <AiOutlineMinusSquare
                      size={20}
                      onClick={() => setMasterAccordian(!masterAccordian)}
                    />
                  ) : (
                    <AiOutlinePlusSquare
                      size={20}
                      onClick={() => setMasterAccordian(!masterAccordian)}
                    />
                  )}{' '}
                  &nbsp;{' '}
                  <span style={{ color: '#092682', font: 'Open Sans' }}>
                    Term 1
                  </span>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid item xs={12}>
                    <KenGrid
                      columns={masterHead}
                      data={[]}
                      pagination={{ disabled: true }}
                      toolbarDisabled={true}
                    />
                  </Grid>
                </AccordionDetails>
              </Accordion>
            )}
          </Grid>
        </Grid>
      </KenDialog>
      <Reference
        title={'Add Reference'}
        // children={}
        selectedTerm={selectedTerm}
        isOpen={confirmDialogAddReference}
        // handleClose={() => setConfirmDialogAddReference(false)}
        handleClose={closeAddReference}
        // handleEvent={handleAddEventRefernce}
        positiveBtn={'Add activity'}
        negativeBtn={'Cancel'}
        // handleSelectSubjectChange={handleSelectSubjectChange}
        sessions={sessions}
        id={null}
        term={term}
        programName={programName}
        intake={intake}
        year={year}
        // subjects={subjects}
        // facultyOptions={facultyOptions}
        // selectSubjectValue={selectSubjectValue}
      />
      {/* Download pdf */}
      <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Download
          </Typography>
        }
        open={downloadDialog}
        handleClose={() => setDowloadDialog(false)}
        negativeButtonClick={() => setDowloadDialog(false)}
        positiveButtonClick={() => handleDownloadPdf()}
        positiveButtonText="Download"
        negativeButtonText="Cancel"
        maxWidth="lg"
        dividers
      >
        <Grid container>
          <Grid item xs={12}>
            <label>Select term to download</label>
          </Grid>
          {rows.length > 0 &&
            rows.map((items) => {
              return (
                <Grid item xs={6} className="checkbox-grid">
                  <KenCheckbox
                    name={items.courseName}
                    className={classes.checkbox}
                    justifyContentbox="start"
                    label={items.courseName}
                    value={termCheckboxlist[items.courseName]}
                    onChange={termCheckboxlistHandler}
                    color="primary"
                  />
                </Grid>
              );
            })}
          <Grid item xs={12} className="downloadMode">
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={modeDownload}
              onChange={handleDownloadermode}
              className="radio-button-group"
            >
              <FormControlLabel
                value="downloadWord"
                control={<Radio />}
                label="Download as Word Document"
              />

              <FormControlLabel
                value="downloadPdf"
                control={<Radio />}
                label="Download as PDF"
              />
            </RadioGroup>
          </Grid>
        </Grid>
      </KenDialog>
      <KenSnackBar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
    </Box>
  );
};

export default AddActivity;
